import { graphql } from '../../../../../../graphql';

export const GET_ADMISSION_STEP_DATA = graphql(`
  query getAdmissionStepData(
    $applicationId: ID!
    $entryYear: String!
    $nominationFilter: NominationFilter!
    $assessmentFilter: AssessmentFilter!
  ) {
    preliminaryCheck(applicationId: $applicationId) {
      rules {
        programmeLevel
        duration
        version
        checkRule {
          item
          result
        }
        result
      }
    }
    entryYearInformation(entryYear: $entryYear) {
      registrationDeadline
    }

    application(id: $applicationId) {
      programmeChoice {
        studyMode
      }
    }
    nominations(filter: $nominationFilter) {
      admission {
        programme
        requirements {
          generalEntranceRequirements {
            requirements
            fulfilled
          }
          englishLanguageRequirements {
            requirements
            fulfilled
          }
        }
      }
      fundings {
        schema
        source
      }
      supervisors {
        isDrcChair
        isDoRPgS
      }
    }
    dsrcAdmission(filter: $assessmentFilter) {
      applicationId
      dsrcDecision
      remarks
      isFirmOffer
      conditions
      conditionDetails {
        requirement
        detail
      }
      plagiarismCheck
      plagiarismFound
      entranceRequirementWaive
      stipendApproval
      rejectionRemarks
      supervisorAccountCodes
      tuitionAssistantshipType
      tuitionFeeAccountCode
      confirmationChairInTeam
      confirmationDoRPgSInTeam
      contactDepartmentPersonName
      contactDepartmentPersonEmail
      contactDepartmentPersonPhone
      conditionFulfillingDeadline
    }
  }
`);
